// Feilinnsikt (PRD 1.0 US22): hver feil får en referanse som vises til
// brukeren og lagres i feilloggen, så administrator kan finne den igjen.
// Bare en kort, renset feiltekst lagres – aldri tokens, notattekst eller
// hele forespørsler.

export type ErrorCategory =
  | "network"
  | "validation"
  | "access"
  | "billing"
  | "unknown";

export {
  newErrorRef,
  refFromMessage,
  sanitizeErrorMessage,
  withRefText,
} from "@shared/errorRef.ts";

type ErrorLike = {
  name?: string;
  message?: string;
  status?: number;
  code?: string;
  unsettled?: boolean;
  body?: { code?: string };
};

export const classifyError = (error: unknown): ErrorCategory => {
  const e = (error ?? {}) as ErrorLike;
  const status = typeof e.status === "number" ? e.status : undefined;
  const code = e.code ?? e.body?.code ?? "";
  const message = `${e.name ?? ""} ${e.message ?? String(error ?? "")}`;
  if (
    e.unsettled ||
    status === 0 ||
    /Failed to fetch|NetworkError|Load failed|timed? ?out|tidsavbrudd/i.test(
      message,
    )
  )
    return "network";
  if (
    status === 401 ||
    status === 403 ||
    code === "42501" ||
    code === "PGRST301"
  )
    return "access";
  if (
    (status != null && status >= 400 && status < 500) ||
    /^(22|23|P0001)/.test(code) ||
    /^Ugyldig/.test(e.message ?? "")
  )
    return "validation";
  return "unknown";
};
